import React from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initial = {
  nome: "",
  email: "",
  telefono: "",
  oggetto: "",
  messaggio: "",
  studio: "",
  consenso: false,
};

export default function Contact() {
  const [form, setForm] = React.useState(initial);
  const [loading, setLoading] = React.useState(false);

  const update = (k) => (e) =>
    setForm((f) => ({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.consenso) {
      toast.error("È necessario acconsentire al trattamento dei dati.");
      return;
    }
    if (form.nome.trim().length < 2 || form.oggetto.trim().length < 2 || form.messaggio.trim().length < 10) {
      toast.error("Compila i campi obbligatori in modo completo.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/contact`, {
        nome: form.nome.trim(),
        email: form.email.trim(),
        telefono: form.telefono.trim() || null,
        oggetto: form.oggetto.trim(),
        messaggio: form.messaggio.trim(),
        studio: form.studio || null,
      });
      toast.success(data.message || "Messaggio inviato correttamente.");
      setForm(initial);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Errore durante l'invio. Riprova più tardi.";
      toast.error(typeof msg === "string" ? msg : "Errore durante l'invio.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contatti" data-testid="contact-section" className="py-24 md:py-32 bg-[#FDFBF7]">
      <div className="container-ed grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="overline mb-6">Contatti</div>
          <h2 className="serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0F172A]">
            Per una <span className="italic text-[#A38A5A]">consulenza riservata</span>.
          </h2>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#57534E]">
            Lo Studio risponde a tutte le richieste entro 48 ore lavorative. I dati
            saranno trattati nel rispetto della normativa vigente in materia di privacy.
          </p>

          <div className="mt-12 space-y-6">
            <div>
              <div className="overline text-[10px] mb-2">Telefono</div>
              <a href="tel:3201862530" className="serif text-2xl text-[#0F172A] hover:text-[#A38A5A] transition-colors block" data-testid="contact-phone-scotti">
                320.1862530 <span className="text-sm text-[#57534E] font-sans ml-2 not-italic">— Avv. Scotti</span>
              </a>
              <a href="tel:3807895960" className="serif text-2xl text-[#0F172A] hover:text-[#A38A5A] transition-colors block mt-1" data-testid="contact-phone-bava">
                380.7895960 <span className="text-sm text-[#57534E] font-sans ml-2 not-italic">— Avv. Bava</span>
              </a>
            </div>
            <div className="hairline pt-6">
              <div className="overline text-[10px] mb-2">Email</div>
              <a href="mailto:avvscotti@legaliscottibava.eu" className="block text-[#1C1917] hover:text-[#A38A5A] transition-colors break-all">avvscotti@legaliscottibava.eu</a>
              <a href="mailto:avvbava@legaliscottibava.eu" className="block text-[#1C1917] hover:text-[#A38A5A] transition-colors mt-1 break-all">avvbava@legaliscottibava.eu</a>
            </div>
            <div className="hairline pt-6">
              <div className="overline text-[10px] mb-2">PEC</div>
              <span className="block text-[#57534E] break-all">avvgiovannascotti@pec.it</span>
              <span className="block text-[#57534E] break-all mt-1">dott.salvatorebava@pec.it</span>
            </div>
          </div>
        </div>

        <form
          onSubmit={onSubmit}
          data-testid="contact-form"
          className="lg:col-span-7 bg-white border border-black/10 p-8 md:p-12"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            <div className="md:col-span-2">
              <label className="overline text-[10px]">Nome e Cognome *</label>
              <input
                data-testid="input-nome"
                type="text"
                required
                minLength={2}
                value={form.nome}
                onChange={update("nome")}
                className="input-ed mt-2"
                placeholder="Mario Rossi"
              />
            </div>
            <div>
              <label className="overline text-[10px]">Email *</label>
              <input
                data-testid="input-email"
                type="email"
                required
                value={form.email}
                onChange={update("email")}
                className="input-ed mt-2"
                placeholder="mario.rossi@email.it"
              />
            </div>
            <div>
              <label className="overline text-[10px]">Telefono</label>
              <input
                data-testid="input-telefono"
                type="tel"
                value={form.telefono}
                onChange={update("telefono")}
                className="input-ed mt-2"
                placeholder="+39 ..."
              />
            </div>
            <div className="md:col-span-2">
              <label className="overline text-[10px]">Studio preferito</label>
              <div className="mt-3 flex flex-wrap gap-3" role="radiogroup">
                {["Chieti", "Bra", "Entrambi"].map((s) => (
                  <label
                    key={s}
                    className={`cursor-pointer px-4 py-2 text-sm border transition-colors ${
                      form.studio === s
                        ? "bg-[#0F172A] text-white border-[#0F172A]"
                        : "border-black/20 text-[#1C1917] hover:border-[#0F172A]"
                    }`}
                  >
                    <input
                      data-testid={`studio-${s.toLowerCase()}`}
                      type="radio"
                      name="studio"
                      value={s}
                      checked={form.studio === s}
                      onChange={update("studio")}
                      className="sr-only"
                    />
                    {s}
                  </label>
                ))}
              </div>
            </div>
            <div className="md:col-span-2">
              <label className="overline text-[10px]">Oggetto *</label>
              <input
                data-testid="input-oggetto"
                type="text"
                required
                minLength={2}
                value={form.oggetto}
                onChange={update("oggetto")}
                className="input-ed mt-2"
                placeholder="Es. Consulenza locazione / licenziamento / penale"
              />
            </div>
            <div className="md:col-span-2">
              <label className="overline text-[10px]">Messaggio *</label>
              <textarea
                data-testid="input-messaggio"
                required
                minLength={10}
                rows={5}
                value={form.messaggio}
                onChange={update("messaggio")}
                className="input-ed mt-2 resize-none"
                placeholder="Descrivi brevemente la tua situazione..."
              />
            </div>
            <div className="md:col-span-2 flex items-start gap-3 text-sm text-[#57534E]">
              <input
                data-testid="input-consenso"
                id="consenso"
                type="checkbox"
                checked={form.consenso}
                onChange={update("consenso")}
                className="mt-1 accent-[#0F172A]"
              />
              <label htmlFor="consenso" className="leading-relaxed">
                Ho preso visione dell'informativa privacy e autorizzo il trattamento dei
                miei dati personali ai sensi del Reg. UE 2016/679 per rispondere alla
                presente richiesta. *
              </label>
            </div>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <p className="text-xs text-[#57534E]">* Campi obbligatori</p>
            <button
              data-testid="contact-submit"
              type="submit"
              disabled={loading}
              className="btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Invio in corso..." : "Invia richiesta"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
